import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface InformationVideoPopupProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const InformationVideoPopup: React.FC<InformationVideoPopupProps> = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-full">
        <DialogHeader>
          <DialogTitle>Bilgilendirme Videosu</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '0px',
              paddingBottom: '56.25%',
            }}
          >
            <iframe
              allow="fullscreen"
              allowFullScreen
              src="https://streamable.com/e/q1q8ya?"
              style={{
                border: 'none',
                width: '100%',
                height: '100%',
                position: 'absolute',
                left: '0px',
                top: '0px',
                overflow: 'hidden',
              }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default InformationVideoPopup
